import { createGlobalStyle } from 'styled-components';

// you can specify global styles here or in the App.
const GlobalStyle = createGlobalStyle`
    .modal-cart-expire {
        overflow: hidden;
    }
`;

export default GlobalStyle;
